import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { hideModal } from 'common/actions/modal'
import Modals from 'modules/models'
import { getModalType, getModalProps } from 'common/selectors/modal'
import * as ModalTypes from '../../constants/ModalTypes'

const MODAL_COMPONENT = {
  [ModalTypes.VERSION_MODAL]: Modals.VersionModal,
  [ModalTypes.DOWNLOAD_SETTINGS]: Modals.DownloadSettings,
  [ModalTypes.CONFIRMATION_MODAL]: Modals.ConfirmationModal,
  [ModalTypes.PROGRAM_SELECTED_MODAL]: Modals.ProgramSelectedModal,
  [ModalTypes.PROGRAMS_MODAL]: Modals.ProgramsModal,
  [ModalTypes.BYPASS_INFO]: Modals.BypassInfoModal,
  [ModalTypes.FILTER_STATUS]: Modals.FilterStatusInfoModal,
  [ModalTypes.EDIT_HOLIDAY_TEMP_MODAL]: Modals.EditHolidayTempModal,
  [ModalTypes.EDIT_TEMP_PKOM_MODAL]: Modals.EditTempPkomModal,
  [ModalTypes.EDIT_ACS_PKOM_MODAL]: Modals.EditAcsPkomModal,
  [ModalTypes.MASTER_SYSTEM_MODAL_CONTAINER]: Modals.MasterSystemModalContainer,
  [ModalTypes.RETURN_DATE_MODAL]: Modals.returnDateModal,
  [ModalTypes.CONDENSATION_RISK_MODAL_CONTAINER]: Modals.CondensationRiskModal
}

export class ModalRoot extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    props: PropTypes.object,
    hideModal: PropTypes.func.isRequired
  }

  render() {
    const { type, props, hideModal } = this.props
    if (!type) return null

    const ModalComponent = MODAL_COMPONENT[type]

    return (
      <ModalComponent
        {...props}
        hideModal={hideModal}
      />
    )
  }
}

const mapStateToProps = state => ({
  type: getModalType(state),
  props: getModalProps(state)
})

const mapActionsToProps = {
  hideModal
}

export default connect(mapStateToProps, mapActionsToProps)(ModalRoot)
